/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import Loader from '../../../../../../../components/Loader';
import DropDownComponent from '../../StudentStatement/Components/DropDownComponent';

export default function Filter({
    ayAndClassOptions, 
    sectionOptions, 
    examOptions, 
    loading,
    setLoading,
    getDefaultValue,
    reportsTotalCount,
    btnLoading, 
    setBtnLoading,
    getSectionOptions,
    getExamOptions,
    searchParams,
    selectedAY, 
    setSelectedAY, 
    selectedSection, 
    setSelectedSection, 
    selectedExam, 
    setSelectedExam,
    setSearchParams,
    getAcademicReports,
    setToastErrorMessage}){

    /**
     * The function `formatOptionName` takes an `option` object as input and returns a formatted string
     * that includes the academic year name and class name from the object.
     */
    const formatOptionName = (option) => option ? `${option?.academic_year?.name}, ${option?.class_name}` : '';

    /**
     * The function `filterDuplicates` removes duplicate items from an array based on a specific condition
     * related to a property called `class_id`.
     * @returns The `filterDuplicates` function returns an array with duplicate items removed based on the
     * `class_id` property. If there are duplicate items with the same `class_id`, the function keeps the
     * existing item if it has `latest: true`, otherwise it replaces it with the current item if the
     * current item has `latest: true`. If both items have `latest: false`, it doesn't matter which
     */
    function filterDuplicates(arr) {
        const filtered = arr.reduce((acc, current) => {
            const existing = acc.find(item => item.class_id === current.class_id);

            if (!existing) {
                acc.push(current);
            } else {
                if (existing.latest && current.latest) {
                // If both have latest: true, keep the existing one (or replace with current if you want)
                } else if (current.latest) {
                    acc = acc.map(item => item.class_id === current.class_id ? current : item);
                }
            // If both are latest: false, it doesn't matter which one to keep.
            }

            return acc;
        }, []);

        return filtered;
    }

    const filteredAyAndClassOptions = filterDuplicates(ayAndClassOptions)

    //The function `handleOnchangeInput` updates the each's dropdowns state based on the selected dropdown and it's value.
    const handleOnchangeInput = (id, item, index) => {
        let newSearchParams = Object.fromEntries(searchParams);
        newSearchParams.dropdown = 'true'
        if (id === "Academic Year & Class") {
            setSelectedSection([])
            setSelectedExam([])
            newSearchParams.ay_id = item?.academic_year?.academic_year_id,
            newSearchParams.class_id = item?.class_id
            delete newSearchParams.sec_id
            delete newSearchParams.exam_id
            setSelectedAY(item)
            setSearchParams(newSearchParams)
            getSectionOptions(item?.academic_year?.academic_year_id, item?.class_id, true)
        } else if (id === "Section(s)") {
            setSelectedExam([])
            newSearchParams.sec_id = item?.section_id
            delete newSearchParams.exam_id
            setSelectedSection(item)  
            setSearchParams(newSearchParams)  
            getExamOptions(item?.academic_year?.academic_year_id, item?.class_id, item?.section_id, item?.latest, true)
        } else if (id === "Exam") {
            newSearchParams.exam_id = item?.exam_id
            setSelectedExam(item)
            setSearchParams(newSearchParams)
        };
    };


    /**
     * The function handleApplyFilter calls the getAcademicReports function again.
     */
    const handleApplyFliter = () => {
        if(examOptions?.length == 0 || sectionOptions?.length === 0 || ayAndClassOptions?.length === 0 || 
            selectedAY?.length ===0  || selectedExam?.length===0 || selectedSection?.length===0){
            if(selectedAY?.length ===0 )
            {
                setToastErrorMessage("No Academic Details available");
                return;        
            }
            if(selectedExam?.length ===0 )
            {
                setToastErrorMessage("No Exam(s) available for the selected AY");
                return;        
            }
            setToastErrorMessage("Incomplete Academic Details");
            return;
        }
        setLoading(true)
        setBtnLoading(true)
        getAcademicReports(
            selectedAY?.academic_year?.academic_year_id, 
            selectedAY.class_id, 
            selectedSection?.section_id, 
            selectedExam?.exam_id
        )
    };

    return(
        <div className="flex h-[6.25rem] border border-[#d0d5dd]">
            {/* Academic Year & Class dropdown */}
            <div className="inline-flex flex-col justify-center items-start gap-1 p-[16px]">
                <p className="date_range text-black leading-6">Academic Year & Class</p>
                <DropDownComponent
                    dropDownName={"Academic Year & Class"}
                    id={"Academic Year & Class"}
                    test_id={"Academic Year & Class"}
                    divClassName={`relative w-[200px] z-40`}
                    value={selectedAY?.length !== 0  ? formatOptionName(selectedAY) : formatOptionName(getDefaultValue(ayAndClassOptions, false, 'ayAndClass', searchParams?.get('dropdown') === 'true'))}
                    placeHolder={"Select Academic Year & Class"}
                    buttonDisabled={loading}
                    buttonClassName={`w-[200px] z-40 border border-[#D0D5DD] rounded py-1.5 px-3.5 pr-[30px] outline-0 text-f7 text-[#031624] text-left font-normal transition duration-150 ease-in-out error_border more-lines ${ayAndClassOptions?.length === 1 ? ' bg-[#E6E8EA] shadow-s12' : 'bg-white '}`}
                    options={ayAndClassOptions}
                    formatOptionName={(option) => option ? formatOptionName(option) : ''} // Custom formatting function
                    handleOnchangeInput={handleOnchangeInput}
                    tooltip={true} />
            </div>
            {/* Sections dropdown */}
            <div className="inline-flex flex-col items-start gap-1 py-[16px] pr-[16px]">
                <p className="select_fy text-black leading-6">Section</p>
                {(loading || sectionOptions?.length === 1) ? (
                    <input
                        type="text"
                        id="Section(s)"
                        name="section_name"
                        value={selectedSection?.section_name}
                        className="w-full inpt-fld"
                        readOnly 
                    />
                ) : (
                    <DropDownComponent
                        dropDownName={"Section(s)"}
                        id={"Section(s)"}
                        nameKey="section_name"
                        test_id={"Section(s)"}
                        divClassName={"relative w-[200px] z-40"}
                        value={selectedSection?.length !== 0 ? selectedSection?.section_name : getDefaultValue(sectionOptions, false)?.section_name}
                        placeHolder={"Select Section"}
                        options={sectionOptions}
                        handleOnchangeInput={handleOnchangeInput}
                        tooltip={true}
                    />
                )
                }
            </div>
            {/* Exam dropdown */}
            <div className="inline-flex flex-col items-start gap-1 py-[16px] pr-[16px]">
                <p className="select_invoice text-black leading-6">Exam</p>
                <DropDownComponent
                    dropDownName={"Exam"}
                    id={"Exam"}
                    test_id={"Exam"}
                    nameKey={"exam_name" || 'exam'}
                    divClassName={`relative w-[200px] z-40`}
                    value={selectedExam?.length !== 0  ? selectedExam?.exam_name ? selectedExam?.exam_name : selectedExam?.exam : getDefaultValue(examOptions, true)?.exam_name}
                    placeHolder={"Select Exam"}
                    buttonDisabled={loading}
                    options={examOptions}
                    handleOnchangeInput={handleOnchangeInput}
                    tooltip={true} />
            </div>
            <div className="flex justify-center items-center ml-auto pr-[18px] pt-[22px]">
                <button onClick={handleApplyFliter} id='apply_filter' data-testid='apply_filter' 
                    className={`actn-btn button_cta `}
                    disabled={ loading }
                    style={{'width':'140px'}}
                >
                    {btnLoading ? <Loader/> : 'Apply Filter'}
                </button>
            </div>
        </div>
    );
}